import { CollectionsListState } from '@src/types/Collection';
import { CollectionView } from 'common';
import { collectionCategories } from '../../../pages/Collection/List/consts';

export function buildCollectionsList(
  collections: CollectionView[],
  comparator: (a: CollectionView, b: CollectionView) => number
): CollectionsListState {
  const categoryMap = new Map<string, string[]>();
  collectionCategories.forEach((cat) => {
    categoryMap.set(cat, []);
  });

  const orderedCollections = [...collections].sort(comparator);
  orderedCollections.forEach((collection) => {
    const key = collection.category ?? 'My selection';
    if (!categoryMap.has(key)) {
      categoryMap.set(key, []);
    }
    const bucket = categoryMap.get(key) ?? [];
    bucket.push(collection._id);
    categoryMap.set(key, bucket);
  });

  return arrayFromMap(categoryMap);
}

export function arrayFromMap(collectionMap: Map<string, string[]>): CollectionsListState {
  return Array.from(collectionMap, ([name, list]) => ({ name, list }));
}
